import * as React from 'react';
import { useTranslation } from '@shopee-user/platform';
import cx from 'classnames';
import styles from './style.scss';

type LoginByPasswordSubmitButtonProps = {
  className?: string;
  disabled?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export default function LoginByPasswordSubmitButton({
  className,
  onClick,
  disabled,
}: LoginByPasswordSubmitButtonProps) {
  const I18n = useTranslation();
  return (
    <button
      type="submit"
      className={cx(styles.button, className)}
      onClick={onClick}
      disabled={disabled}
    >
      {I18n.t('label_auth_log_in')}
    </button>
  );
}
